import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type LabelColor = 'cyan' | 'amber' | 'lavender' | 'mint' | 'coral' | 'sky' | 'rose' | 'sand';
export type Tone = 'neutral' | 'signal' | 'success' | 'warning' | 'danger' | 'info' | LabelColor;

const toneVar = (tone: Tone) =>
  tone === 'neutral'
    ? null
    : ['signal', 'success', 'warning', 'danger', 'info'].includes(tone)
      ? `--color-${tone}`
      : `--color-label-${tone}`;

/** Pílula para status, papel, tag. Cor em pequena área: texto + fundo suave. */
export function Badge({
  tone = 'neutral',
  dot,
  children,
  className,
}: {
  tone?: Tone;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}) {
  const v = toneVar(tone);
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-1.5 rounded-full px-2.5 text-[12px] font-medium whitespace-nowrap',
        !v && 'bg-hover text-fg-muted',
        className,
      )}
      style={
        v ? { color: `var(${v})`, background: `color-mix(in srgb, var(${v}) 13%, transparent)` } : undefined
      }
    >
      {dot && <span className="size-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}

export function StatusDot({ tone, className }: { tone: Tone; className?: string }) {
  const v = toneVar(tone);
  return (
    <span
      className={cn('inline-block size-2 rounded-full', className)}
      style={{ background: v ? `var(${v})` : 'var(--color-fg-subtle)' }}
    />
  );
}
